import {
  MsalBroadcastService,
  MsalGuard,
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
  MsalRedirectComponent,
  MsalService,
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
} from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  IPublicClientApplication,
  PublicClientApplication,
  LogLevel,
  InteractionType,
  SilentRequest,
} from '@azure/msal-browser';
import { isIE } from '../util/is-ie';
import { environment } from '../../environments/environment';
import { getParentWebsite } from '../util/check-bus-site';
import { ParentWebsite } from '../types';

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}

export const b2cPolicies = {
  names: {
    signUpSignIn: environment.b2c.signUpSignInPolicy,
  },
  authorities: {
    signUpSignIn: {
      authority: `${environment.b2c.authority}/${environment.b2c.signUpSignInPolicy}`,
    },
  },
  authorityDomain: environment.b2c.authorityDomain,
};

export const silentGetLoginTokenRequest: SilentRequest = {
  authority: b2cPolicies.authorities.signUpSignIn.authority,
  scopes: ['openid'],
  forceRefresh: true,
};

export function MSALInstanceFactory(): IPublicClientApplication {
  const { redirectUris, clientId } = environment.b2c;

  const parentWebsite: ParentWebsite = getParentWebsite();

  return new PublicClientApplication({
    auth: {
      authority: b2cPolicies.authorities.signUpSignIn.authority,
      knownAuthorities: [b2cPolicies.authorityDomain],
      clientId,
      redirectUri: redirectUris[parentWebsite].redirectUri,
      postLogoutRedirectUri: redirectUris[parentWebsite].postLogoutRedirectUri,

      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11. Remove this line to use Angular Universal
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [],
    },
    loginFailedRoute: '/login-failed',
  };
}

export const MsalProviders = [
  {
    provide: MSAL_INSTANCE,
    useFactory: MSALInstanceFactory,
  },
  {
    provide: MSAL_GUARD_CONFIG,
    useFactory: MSALGuardConfigFactory,
  },
  {
    provide: MSAL_INTERCEPTOR_CONFIG,
    useFactory: MSALInterceptorConfigFactory,
  },
  MsalService,
  MsalGuard,
  MsalBroadcastService,
];

export const MsalBootstrapComponents = [MsalRedirectComponent];
